"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var system_1 = require("../system");
// @ts-ignore
var tooltip_arrow_dark_svg_1 = __importDefault(require("./assets/tooltip-arrow-dark.svg"));
// @ts-ignore
var tooltip_arrow_light_svg_1 = __importDefault(require("./assets/tooltip-arrow-light.svg"));
var common_1 = require("./common");
var systemColors = (_a = {},
    _a[system_1.SystemColors.BgMain] = 'rgba(255,255,255,1)',
    _a[system_1.SystemColors.TextInvert] = 'rgba(255,255,255,1)',
    _a[system_1.SystemColors.BgMinor] = 'rgba(245,244,242,1)',
    _a[system_1.SystemColors.Divider] = 'rgba(0,0,0,0.08)',
    _a[system_1.SystemColors.ButtonMinor] = 'rgba(241,240,237,1)',
    _a[system_1.SystemColors.ControlMinor] = 'rgba(231,229,225,1)',
    _a[system_1.SystemColors.Line] = 'rgba(210,208,204,1)',
    _a[system_1.SystemColors.IconMinor] = 'rgba(196,194,190,1)',
    _a[system_1.SystemColors.TextMinor] = 'rgba(158,155,152,1)',
    _a[system_1.SystemColors.IconMain] = 'rgba(33,32,31,1)',
    _a[system_1.SystemColors.TextMain] = 'rgba(33,32,31,1)',
    _a[system_1.SystemColors.BgInvert] = 'rgba(48,47,45,1)',
    _a[system_1.SystemColors.SubtleAccent] = 'rgba(255,249,229,1)',
    _a[system_1.SystemColors.SelectedListItem] = 'rgba(250,240,85,1)',
    _a[system_1.SystemColors.ButtonMain] = 'rgba(252,224,0,1)',
    _a[system_1.SystemColors.ControlMain] = 'rgba(252,185,0,1)',
    _a[system_1.SystemColors.Link] = 'rgba(77,64,249,1)',
    _a[system_1.SystemColors.BgSuccess] = 'rgba(28,192,82,1)',
    _a[system_1.SystemColors.TextSuccess] = 'rgba(1, 133, 76, 1)',
    _a[system_1.SystemColors.BgAttention] = 'rgba(250,106,60,1)',
    _a[system_1.SystemColors.TextAttention] = 'rgba(206,74,46,1)',
    _a);
var neutralColors = (_b = {},
    _b[system_1.NeutralColors.Text] = 'rgba(97,115,135,1)',
    _b[system_1.NeutralColors.BgGradient] = 'linear-gradient(148.65deg, #E3D7D5 0%, #DDDDEB 86.61%)',
    _b[system_1.NeutralColors.BgOpaque] = 'rgba(228,236,243,1)',
    _b[system_1.NeutralColors.BgTransparent] = 'rgba(195,206,219,0.6)',
    _b);
var colorsScheme = {
    system: systemColors,
    neutral: neutralColors,
};
var defaultButtonScheme = (0, common_1.buttonDefaultScheme)(colorsScheme);
var effectsScheme = {
    bottomShadow: '0px 8px 20px rgba(117, 115, 111, 0.2)',
    topShadow: '0px -8px 20px rgba(117, 115, 111, 0.2)',
    loadingGradient: "\n        linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0) 0,\n            rgba(255, 255, 255, 0.2) 20%,\n            rgba(255, 255, 255, 0.8) 60%,\n            rgba(255, 255, 255, 0)\n        )",
    overlayColor: '0,0,0',
};
var effects = (0, common_1.effectMixins)(effectsScheme);
var typography = (0, common_1.typographyMixins)(colorsScheme);
var paper = (0, common_1.paperMixin)(effects, typography, colorsScheme);
exports.theme = {
    schemes: {
        colors: colorsScheme,
        components: {
            buttons: {
                default: defaultButtonScheme,
            },
            lists: {
                selectedTextColor: colorsScheme.system.TextMain,
                selectedTextMinorColor: colorsScheme.system.TextMinor,
            },
            tooltips: {
                arrowPath: tooltip_arrow_light_svg_1.default,
                invertArrowPath: tooltip_arrow_dark_svg_1.default,
            },
            header: common_1.headerScheme,
        },
        spacing: {
            units: system_1.Spacing,
            spacingScheme12: common_1.spacingScheme12,
            spacingScheme15: common_1.spacingScheme15,
        },
        effects: effectsScheme,
        thickness: common_1.thicknessScheme,
    },
    mixins: {
        effects: effects,
        typography: typography,
        paper: paper,
    },
};
